import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-4">
      <div className="container mx-auto px-4 flex justify-between items-center">
        <div>
          <p>KUWENTO &copy; 2024</p>
          <p>Phone: (425) 746-5747</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
